export function stringToColor(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  let color = '#'
  for (let k = 0; k < 3; k++) {
    const value = (hash >> (k * 8)) & 0xff
    color += ('00' + value.toString(16)).substr(-2)
  }
  return color.substring(0, 7)
}

/**
 * Push an item to a ring buffer array. If the buffer exceeds maxSize, the oldest entry is removed.
 */
export function pushToRingBuffer<T>(buffer: T[], item: T, maxSize: number): void {
  buffer.push(item)
  if (buffer.length > maxSize) {
    buffer.shift()
  }
}

/**
 * Type guard to check if a value is an Error-like object
 */
export function isError(value: unknown): value is { name: string; message: string } {
  return (
    value instanceof Error || (typeof value === 'object' && value !== null && 'name' in value && 'message' in value)
  )
}
